// Copyright (c) 2017 Deere & Company

import LaborAdditiveSummaries from '../state/labor-additive-summaries';
import actions from '../actions-list';
import {getDefaultState} from '../state';

const updateLaborAdditiveSummaries = (state, action) =>
    LaborAdditiveSummaries.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().laborAdditiveSummaries, action) => {

    const actionTypes = {
        [actions.READ_HOME_PAGE_LABOR_ADDITIVE_SUMMARY]: updateLaborAdditiveSummaries
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/home-page/reducers/labor-additive-summaries.js